import { GET_CHAIN } from "../types";

export const chain = (address) => {

    return {
        type: GET_CHAIN,
        payload: address
    };
};